import React from "react";
import {StatoWeekPLUSRecord} from "@commons/mapping/StatoWeekPLUSRecord";
import {DateTime} from "luxon";
import {LavoratorePresenzeRecord} from "@commons/mapping/LavoratorePresenzeRecord";
import {RiepilogoOrePlus} from "@commons/mapping/RiepilogoOrePlus";
import css from '../calendarioPresenze_WF.module.css'
import {mm2HHmmFormat} from "@commons/utils/util";
import TooltipEx from "@components/Tooltip";
import classNames from "classnames";
import {PageType} from "../dashboardWF/wf.dashboard.detail";
import {useAppSelector} from "@hooks/redux-hooks/hooks";
import {selectSitePreferences} from "@commons/core.slice";
import {IconAlertCircleFilled, IconArrowRight, IconCircleCheckFilled, IconClock, IconFileText, IconLockFilled} from "@tabler/icons-react";
import {TabellaWFRecord} from "@commons/mapping/TabellaWFRecord";

interface WeekProps {
    page: PageType,
    tabellaWF?: TabellaWFRecord,
    week: StatoWeekPLUSRecord,
    lavoratore: LavoratorePresenzeRecord,
    weekOpen?: boolean,
    setNextCurrentWeek?: React.Dispatch<React.SetStateAction<number | null>>,
    isGMAvviata?: boolean
}

export const WeekCell: React.FC<WeekProps> = ({
                                                  page, tabellaWF, week, lavoratore, weekOpen,
                                                  setNextCurrentWeek, isGMAvviata
                                              }) => {
    const presenzeOpts = useAppSelector(selectSitePreferences).presenzeOptions;
    const GPlusVistaCalendario = (page === 'Presenze' && (presenzeOpts && presenzeOpts.dayView === 'calendario'));
    const showWeekTotal = true;//(page === 'Presenze' && (presenzeOpts && presenzeOpts.showWeekTotal));

    const isHired = StatoWeekPLUSRecord.isHired(week);

    let weekNumber = week.dtInizioWeek ? DateTime.fromISO(week.dtInizioWeek).toFormat('WW') : '??';

    const checkXWF = (page === "WF" && tabellaWF);


    const hLavTooMuchClass = week.totali && RiepilogoOrePlus.isTotHLavTooMuch(week.totali) ? 'text-warning' : '';
    const HHLav = RiepilogoOrePlus.getTotaleHLav(week.totali);
    const HHPrev = RiepilogoOrePlus.getTotaleHPrev(week.totali);

    const getTotaleHContr = (lavoratore: LavoratorePresenzeRecord, week: StatoWeekPLUSRecord) => {
        const dtInizioWeek = DateTime.fromISO(week.dtInizioWeek!);
        const dtFineWeek = DateTime.fromISO(week.dtFineWeek!);
        const orarioProprietaInizio = LavoratorePresenzeRecord.getOrarioProprieta(lavoratore!, dtInizioWeek);
        const orarioProprietaFine = LavoratorePresenzeRecord.getOrarioProprieta(lavoratore!, dtFineWeek);
        if (orarioProprietaInizio && orarioProprietaFine) {
            if (orarioProprietaInizio.hhWeekMedie === orarioProprietaFine.hhWeekMedie) {
                return mm2HHmmFormat(orarioProprietaInizio.hhWeekMedie * 60);
            } else {
                let hhInizio = orarioProprietaInizio.hhWeekMedie;
                let hhFine = orarioProprietaFine.hhWeekMedie;
                return <div className="flex items-center">{mm2HHmmFormat(hhInizio * 60)}<IconArrowRight className="h-4 w-5"/>{mm2HHmmFormat(hhFine * 60)}</div>;
            }
        }
        return '??,??';
    };

    const divOpen = (weekOpen ? 'border-x border-t !border-[#63cde1] rounded-t focus:outline-none bg-[#63cde1] !mb-0' : '');
    const iconStyle = GPlusVistaCalendario ? 'h-4 w-4 2xl:h-5 2xl:w-5' : 'h-[18px] w-[18px] 2xl:h-5 2xl:w-5';


    return <div key={week.numWeek}
        // className={classNames(GPlusVistaCalendario ? css.weekContainerCalendario : (css.weekContainer + ' min-h-[280px] w-28 2xl:max-w-40'), (weekOpen && page !== 'WF') ? divOpen : '')}
                className={classNames((!GPlusVistaCalendario) ? 'min-h-[280px] w-28 lg:w-32 2xl:w-36' : '', (weekOpen && page !== 'WF') ? divOpen : '')}
                onKeyDownCapture={(event: any) => {
                    // if (page !== 'WF' && setNextCurrentWeek && isHired)
                    if (showWeekTotal && setNextCurrentWeek && isHired)
                        event.key === 'Escape' && setNextCurrentWeek(null)
                }}>

        <div className={classNames(css.weekPanel, !isHired ? css.bgWeekDisabled : '', !showWeekTotal ? 'cursor-default' : 'cursor-pointer')}
             onClick={() => {
                 // if (!isGMAvviata && (page !== 'WF' && setNextCurrentWeek && isHired))
                 if (showWeekTotal && !isGMAvviata && (setNextCurrentWeek && isHired))
                     setNextCurrentWeek(weekOpen ? null : week.numWeekKey)
             }}
             onKeyDownCapture={(event: any) => {
                 //if (page !== 'WF' && setNextCurrentWeek && isHired)
                 if (showWeekTotal && setNextCurrentWeek && isHired)
                     event.key === 'Escape' && setNextCurrentWeek(null)
             }}>
            <div
                className={classNames(isHired ? css.weekColor : css.bgHeaderWeekDisabled, css.headWeekPanel, GPlusVistaCalendario ? 'md:text-lg xl:text-xl 2xl:text-2xl' : 'text-lg md:text-xl xl:text-2xl', !isHired ? '!text-gray-400' : '')}>
                <div className="w-1/2">{weekNumber}</div>
                <div className="w-1/2 inline-flex">
                    {(!isHired || !week.anomalia) &&
                        <IconCircleCheckFilled
                            className={classNames('first:ml-auto grow-0 shrink-0', week.forzabile ? 'text-warning' : 'text-ggQuadrata', !isHired ? '!text-gray-400' : '', iconStyle)}/>}
                    {isHired && week.anomalia && <IconAlertCircleFilled className={classNames('first:ml-auto grow-0 shrink-0 text-anomalia', iconStyle)}/>}
                    {isHired && week.statoWeek > 0 && <IconLockFilled className={classNames('grow-0 shrink-0 text-warning', iconStyle)}/>}
                </div>
            </div>
            {isHired && <>
                <div className="px-2 w-full text-[11px] md:text-xs">
                    <TooltipEx tooltip="Totale ore settimanali da contratto">
                        <span className="inline-flex items-center">
                            <><IconFileText className="size-3 md:size-4 text-xs"/>&nbsp;{getTotaleHContr(lavoratore, week)}</>
                        </span>
                    </TooltipEx>
                </div>
                <div className="px-2 w-full md:inline-flex overflow-ellipsis truncate text-[11px] md:text-xs">
                    {(page === 'Presenze' || (checkXWF && (tabellaWF.showOreLavorate || tabellaWF.showOrePreviste))) && <>
                        <IconClock className={`size-3 md:size-4 grow-0 shrink-0 ${hLavTooMuchClass}`}/>&nbsp;
                    </>}

                    {(page === 'Presenze' || (checkXWF && tabellaWF.showOreLavorate)) && <>
                        <TooltipEx tooltip="Totale settimana ore lavorate"><span className={hLavTooMuchClass}>{mm2HHmmFormat(HHLav)}</span></TooltipEx></>}

                    {(page === 'Presenze' || (checkXWF && (tabellaWF.showOreLavorate && tabellaWF.showOrePreviste))) && <>&#47;</>}

                    {(page === 'Presenze' || (checkXWF && tabellaWF.showOrePreviste)) && <>
                        <TooltipEx tooltip="Totale settimana ore previste"><span className={week.anomalia ? 'text-anomalia' : ''}>{mm2HHmmFormat(HHPrev)}</span>
                        </TooltipEx></>}
                </div>
            </>
            }
        </div>
    </div>
};